import { useMenuState, useClick } from "@szhsin/react-menu";
import { useRef } from "react";
import { useClickMenu } from "./useClickMenu";

export function useReactMenuProps() {
  const profMenu = useRef(null);

  const [menuState, toggleMenu] = useMenuState({
    transition: true,
    transitionTimeout: 120,
  });
  const anchorProps = useClick(menuState.state, (open) => {
    toggleMenu(open);
  });

  const clickMenu = useClickMenu();

  return {
    controlledMenuProps: {
      anchorRef: profMenu,
      className: "cvp-react-menu",
      ...menuState,
      onClose: () => toggleMenu(false),
      submenuOpenDelay: clickMenu ? 999999999 : 0,
      submenuCloseDelay: clickMenu ? 999999999 : 0,
    },
    btnProps: {
      ref: profMenu,
      ...anchorProps,
    },
  };
}
